module.exports = __webpack_public_path__ + "static/media/plus.a591679f.png";